__webpack_require__.p = "/reports-requisitions-missing-translations/referrals-hub/";